import flowRight from "lodash.flowright";

import param from "./params";

type UrlType = {
  host?: string;
  path: string;
};

const replaceParam = (params) => (url, key) =>
  url.replace(new RegExp(`:${key}`, "g"), params[key]);

const isObject = (p) => typeof p === "object";

const applyUrlParts = (url) => {
  return isObject(url) ? `${url.host}${url.path}` : url;
};

const applyParams =
  (params = {}) =>
  (url) =>
    Object.keys(params).reduce(replaceParam(params), url);

const applyQueryString =
  (qs = {}) =>
  (url) => {
    const qsParams = param(qs);
    return qsParams ? `${url}?${qsParams}` : url;
  };

// eslint-disable-next-line import/no-anonymous-default-export
export default (url: UrlType | string, params = {}, qs = {}) =>
  decodeURIComponent(
    flowRight(applyQueryString(qs), applyParams(params), applyUrlParts)(url),
  );
